package com.sddamico.swigmore.util

import com.sddamico.swigmore.api.WeekRef

/** The header's tabs, in order. */
enum class AppTab(val label: String, val path: String) {
  Poll("Poll", "/"),
  Ballot("My Ballot", "/ballot"),
  Results("Results", "/results"),
  ComputerPolls("Computer Polls", "/computer-polls"),
  Archive("Record Book", "/archive"),
  Admin("Commish", "/admin"),
}

/** Routes that take parameters. */
object Routes {
  const val SIGN_IN = "/signin"

  /** Sign-in, then back to [next]. */
  fun signIn(next: String) = "$SIGN_IN?next=${js("encodeURIComponent")(next) as String}"

  fun archive(season: Int) = "${AppTab.Archive.path}?season=$season"

  fun announce(week: WeekRef) = "${AppTab.Admin.path}/announce?season=${week.season}&week=${week.week}"
}

/** A link's `?season=`: null when absent, a failure when it isn't a number. */
fun seasonParam(season: String?): Result<Int?> =
  if (season == null) Result.success(null)
  else season.toIntOrNull()?.let { Result.success(it) } ?: Result.failure(IllegalArgumentException("Season must be a number"))

/** A link's `?season=&week=`: null when neither is given, a failure unless both are numbers. */
fun weekParam(season: String?, week: String?): Result<WeekRef?> {
  if (season == null && week == null) return Result.success(null)
  val s = season?.toIntOrNull()
  val w = week?.toIntOrNull()
  return if (s != null && w != null) Result.success(WeekRef(s, w))
  else Result.failure(IllegalArgumentException("Pass both season and week as numbers"))
}
